import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ShieldCheckIcon, ZapIcon, BookOpenIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
export function CTASection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="cta-section" ref={ref} className="w-full bg-gradient-to-br from-terracotta to-terracotta/90 py-16 md:py-24 px-6" data-id="element-13">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.7
    }} className="max-w-4xl mx-auto text-center" data-id="element-14">
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-15">
          Recupera tu tranquilidad y el sueño de tu bebé hoy mismo
        </h2>

        <p className="text-xl md:text-2xl text-white/90 mb-12" data-id="element-16">
          Por un precio menor al de una caja de pañales
        </p>

        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 md:p-12 mb-10 max-w-lg mx-auto" data-id="element-17">
          <BookOpenIcon className="w-10 h-10 text-white/80 mx-auto mb-4" data-id="element-18" />
          <h3 className="font-serif text-2xl font-bold text-white mb-2" data-id="element-19">
            Ebook
          </h3>
          <p className="text-white/70 text-sm mb-6" data-id="element-20">Terapia de Sueño 7-Min</p>

          <p className="text-white/50 text-lg line-through mb-1" data-id="element-21">$300 MXN</p>
          <span className="inline-block bg-white/20 text-white text-xs font-semibold px-3 py-1 rounded-full mb-3" data-id="element-22">
            -62% de descuento
          </span>
          <p className="font-serif text-5xl md:text-6xl font-bold text-white mb-1" data-id="element-23">
            $111.49
          </p>
          <p className="text-white/70 text-sm mb-6" data-id="element-24">MXN · Pago único</p>

          <ul className="text-left text-white/80 text-sm space-y-2 mb-8 max-w-xs mx-auto" data-id="element-25">
            <li className="flex items-start gap-2" data-id="element-26">
              <span className="text-soft-gold mt-0.5" data-id="element-27">✓</span>
              Ebook con el método 1-2-4 completo
            </li>
            <li className="flex items-start gap-2" data-id="element-28">
              <span className="text-soft-gold mt-0.5" data-id="element-29">✓</span>
              Guía de Emergencia 3 AM
            </li>
            <li className="flex items-start gap-2" data-id="element-30">
              <span className="text-soft-gold mt-0.5" data-id="element-31">✓</span>
              Checklist "Estación de Calma"
            </li>
          </ul>

          <a href="https://serenopulse.com/cart/47610504020226:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart('Ebook Terapia de Sueño 7-Min', 6.39)} className="inline-block bg-white hover:bg-cream text-terracotta font-bold text-xl px-12 py-6 rounded-full shadow-2xl transition-all duration-300 hover:scale-105 w-full md:w-auto text-center" data-id="element-32">
            QUIERO EL MÉTODO 7-MIN AHORA
          </a>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-white/90" data-id="element-33">
          <div className="flex items-center gap-2" data-id="element-34">
            <ZapIcon className="w-5 h-5" data-id="element-35" />
            <span data-id="element-36">Acceso inmediato tras la compra</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-37">
            <ShieldCheckIcon className="w-5 h-5" data-id="element-38" />
            <span data-id="element-39">100% Seguro</span>
          </div>
        </div>

        <p className="text-white/80 text-sm md:text-base italic mt-8" data-id="element-40">
          Miles de mamás ya están durmiendo mejor. Únete a ellas esta noche.
        </p>
      </motion.div>
    </section>;
}